<template lang="pug">
.d-contents
  p Для объединения ваших учетных записей авторизируйтесь через вашу другую учетную запись.
  div
    app-button(
      rounded
      outlined
      @click="onInitClick"
    )
      v-icon(
        :size="24"
        left
      ).mr-1 {{ source.icon }}
      span Войти
</template>

<script>
import AppButton from '@/components/user-redesign/controls/AppButton.vue';

export default {
  name: 'MergeSocial',
  components: {
    AppButton,
  },
  props: {
    source: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    onInitClick() {
      this.$emit('click:init');
    },
  },
};
</script>
